module.exports = __webpack_public_path__ + "media/images/employees/kamill-ab7889e52e6a9fdf993bc83a6b470e74.png";